if (!customElements.get("scroll-indicator")) {
  class ScrollIndicator extends HTMLElement {
    constructor() {
      super();
      this.progressBar = this.querySelector('.progress-bar');
      if(!this.progressBar) return;
    }

    connectedCallback() {
      this.boundAnimateScroll = this.animateScroll.bind(this);
      window.addEventListener('scroll', this.boundAnimateScroll);
    }

    disconnectCallback() {
      if (this.boundAnimateScroll) {
        window.removeEventListener('scroll', this.animateScroll);
      }
    }

    animateScroll() {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (winScroll / height) * 100;
      this.progressBar.style.width = scrolled + "%";
    }
  }

  customElements.define("scroll-indicator", ScrollIndicator);
}
